// Utility functions for safe authentication handling

export const getAuthToken = (): string => {
  try {
    return localStorage.getItem('token') || '';
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return '';
  }
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};

export const clearAuthToken = () => {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  } catch (error) {
    console.error('Error clearing auth data:', error);
  }
};